// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__Ma-0s","contactText":"Contact_contactText__QoE8X"};